<template>
  <div
    :class="{ 'has-logo': showLogo }"
    :style="{ backgroundColor: bgColor }"
  >
    <div class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :text-color="textColor"
        :unique-opened="true"
        active-text-color="#502ee2"
        :collapse-transition="false"
        :popper-offset="0"
        mode="vertical"
      >
        <div style="position: absolute; width: 100%; right: 0; left: 0">
          <sidebar-item
            v-for="(r, index) in sidebarRouters"
            :key="r.path + index"
            :item="r"
            :base-path="r.path"
          />
        </div>
      </el-menu>
    </div>
    <div
      class="getInfo"
      style="display: flex; width: 80%; margin: 0 auto; flexwrap: wrap"
    >
      <actions
        :collapse="isCollapse"
        :title="proxy.$t('navbar.admin')"
        url="/user/profile"
      />
      <actions
        :collapse="isCollapse"
        :title="proxy.$t('navbar.updata')"
        url="/getNotice"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SidebarItem from './SidebarItem.vue';
import variables from '@/assets/styles/variables.module.scss';
import { useAppStore } from '@/store/modules/app';
import { useSettingsStore } from '@/store/modules/settings';
import { usePermissionStore } from '@/store/modules/permission';
import { RouteRecordRaw } from 'vue-router';
import actions from './actions.vue';

const { proxy } = getCurrentInstance() as ComponentInternalInstance;

const route = useRoute();
const appStore = useAppStore();
const settingsStore = useSettingsStore();
const permissionStore = usePermissionStore();
const sidebarRouters = computed<RouteRecordRaw[]>(() => permissionStore.getSidebarRoutes());
const showLogo = computed(() => settingsStore.sidebarLogo);
const sideTheme = computed(() => settingsStore.sideTheme);
const isCollapse = computed(() => !appStore.sidebar.opened);

const activeMenu = computed(() => {
  const { meta, path } = route;

  // if set path, the sidebar will highlight the path you set
  if (meta.activeMenu) {
    return meta.activeMenu;
  }

  return path;
});

const bgColor = computed(() => (sideTheme.value === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground));
const textColor = 'var(--el-text-color-regular)';
</script>
<style scoped lang="scss">
.getInfo {
  border-top: 1px #e4e0e0 solid;
}
</style>
